module.exports = __webpack_public_path__ + "static/img/Poweramp.3502621b.png";